/** Run once when a preview approaches the viewport, with a usable old-browser fallback. */
export function whenVisible(element: Element, run: () => void, rootMargin = "300px") {
  if (!("IntersectionObserver" in window)) {
    run();
    return () => {};
  }
  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    observer.disconnect();
    run();
  }, { rootMargin });
  observer.observe(element);
  return () => observer.disconnect();
}

/** Decorative downloads must wait for the initial page and a quiet interval. */
export function afterPageLoadAndIdle(run: () => void) {
  let timer: number | undefined;
  let idle: number | undefined;
  const schedule = () => {
    timer = window.setTimeout(() => {
      if ("requestIdleCallback" in window) {
        idle = window.requestIdleCallback(run);
      } else {
        run();
      }
    }, 2000);
  };
  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
  return () => {
    window.removeEventListener("load", schedule);
    window.clearTimeout(timer);
    if (idle !== undefined) window.cancelIdleCallback(idle);
  };
}

export function allowsAutomaticVideo(input: {
  reducedMotion: boolean;
  saveData?: boolean;
  effectiveType?: string;
  downlink?: number;
}) {
  return !input.reducedMotion && !input.saveData &&
    !["slow-2g", "2g", "3g"].includes(input.effectiveType ?? "") &&
    (input.downlink === undefined || input.downlink >= 2);
}
